import React from 'react'
import { graphql } from 'gatsby'
import get from 'lodash/get'
import { Helmet } from 'react-helmet'

import './base.css'
import './index.css'
import SectionCaption from '../layouts/sectioncaption'
import Layout from '../layouts/layout'
import Hero from '../components/hero'
import Tags from '../components/tags'
import WaveSection from '../layouts/wavesection'
import Blogs from './blogs/components/blogs.js'
import ToTop from '../layouts/totop.js'
import Gallery from '../components/deferred-gallery'
import DeferredRender from '../components/deferred-render.js'
import { TwentyTwoEntry, FootprintsEntry } from '../components/home-entries'
import { contentfulImageSrcSet, contentfulImageUrl } from '../lib/contentful-image'
import SEO, {
  HOMEPAGE_TITLE as homepageTitle,
  PERSON_ID,
  SITE_URL,
  personStructuredData,
} from '../components/seo'

class RootIndex extends React.Component {
  constructor(props) {
    super(props)

    const backgrounds = get(props, 'data.allContentfulBackground.edges', [])
    const mottos = get(props, 'data.allContentfulMotto.edges')
    const avatars = get(props, 'data.allContentfulAvatar.edges')
    const totalNum = 4
    const waveSectionData = Array.from({ length: totalNum }, (_, index) => ({
      image: get(backgrounds[index % backgrounds.length], 'node.bg.fluid.src', ''),
      logo: avatars[this.handleRandomNum(avatars.length - 1)].node.img.fluid.src,
      text: mottos[this.handleRandomNum(mottos.length - 1)].node.text,
    }))

    this.state = {
      homepageTitle,
      totalNum,
      backgroundOffset: 0,
      wave_section_data: waveSectionData,
      backgrounds,
      mottos,
      avatars,
    }
  }

  componentDidMount(){
    this.updateHomepageTitle()
    window.addEventListener('languagechange', this.updateHomepageTitle)

  }

  componentWillUnmount(){
    window.removeEventListener('languagechange', this.updateHomepageTitle)
    clearInterval(this.timerID);
  }

  updateHomepageTitle = () => {
    const language = (navigator.languages && navigator.languages[0]) || navigator.language
    this.setState({
      homepageTitle: !language || /^zh(?:[-_]|$)/i.test(language)
        ? homepageTitle
        : 'Live Well - Zhe Zhang’s Personal Website',
    })
  }

  activeWaves = new Set()

  handleWaveActivity = (index, active) => {
    if (active) this.activeWaves.add(index)
    else this.activeWaves.delete(index)
    if (this.activeWaves.size && !this.timerID) {
      this.timerID = setInterval(this.handleRandomWaveSection, 20000)
    } else if (!this.activeWaves.size && this.timerID) {
      clearInterval(this.timerID)
      this.timerID = null
    }
  }

  handleRandomWaveSection = () => {
    this.setState(({ backgrounds, avatars, mottos, totalNum, backgroundOffset }) => {
      // Rotate through the collection without repeating a background in one view.
      const nextOffset = backgrounds.length ? (backgroundOffset + 1) % backgrounds.length : 0
      const waveSectionData = Array.from({ length: totalNum }, (_, index) => ({
        image: get(backgrounds[(index + nextOffset) % backgrounds.length], 'node.bg.fluid.src', ''),
        logo: avatars[this.handleRandomNum(avatars.length - 1)].node.img.fluid.src,
        text: mottos[this.handleRandomNum(mottos.length - 1)].node.text,
      }))

      return { wave_section_data: waveSectionData, backgroundOffset: nextOffset }
    })
  }

  handleRandomNum = (length) => {
    return parseInt(Math.random() * ( length + 1 ), 10); 
  }

  render() {
    console.log("将要面对的与已成过往的，较之深埋内心的，皆为微末。")
    const heros = get(this, 'props.data.allContentfulHero.edges')
    const heroImage = heros[0].node.bg.fluid.src
    const heroImageSrc = contentfulImageUrl(heroImage, 960, 45)
    const heroImageSrcSet = contentfulImageSrcSet(heroImage, [480, 640, 960, 1280], 45)
    const tags = get(this, 'props.data.allContentfulTag.edges')

    const socialmedias = get(this, 'props.data.allContentfulSocialMedia.edges')
    const blogposts = get(this, 'props.data.allContentfulBlogPost.edges')

    const photogallerys = get(this, 'props.data.allContentfulPhotoGallery.edges')

    return (
      <Layout location={this.props.location} socialmedias={socialmedias}>

        <SEO
          title={this.state.homepageTitle}
          pathname="/"
          structuredData={[
            personStructuredData,
            {
              '@type': 'WebSite',
              '@id': `${SITE_URL}/#website`,
              url: `${SITE_URL}/`,
              name: 'doubleZ 的个人网站',
              alternateName: [
                '张喆的个人网站',
                'Zhe Zhang Homepage',
                'Zhang Zhe Homepage',
              ],
              inLanguage: ['zh-CN', 'en'],
              author: { '@id': PERSON_ID },
            },
            {
              '@type': 'ProfilePage',
              '@id': `${SITE_URL}/#profile-page`,
              url: `${SITE_URL}/`,
              name: this.state.homepageTitle,
              mainEntity: { '@id': PERSON_ID },
              isPartOf: { '@id': `${SITE_URL}/#website` },
              inLanguage: 'zh-CN',
            },
          ]}
        />

        <Helmet bodyAttributes={{ class: 'HomePageDocument' }}>
          <link rel='preconnect' href='https://images.ctfassets.net' crossOrigin='anonymous' />
          <link
            rel='preload'
            as='image'
            href={heroImageSrc}
            imagesrcset={heroImageSrcSet}
            imagesizes='100vw'
            fetchpriority='high'
          />
        </Helmet>
        <ToTop />

        <main className="HomePage">
        <Hero data={heros} />

        <a className="NavigatorAnchor" id="life-trace" name="life-trace">life-trace</a>
        <Tags data={tags} />

        {/* <a className="NavigatorAnchor" id="for-the-time">for-the-time</a>
        <ForTheTime /> */}

        <WaveSection
            index={0}
          onActivityChange={this.handleWaveActivity}
          image={this.state.wave_section_data[0].image}
            logo={this.state.wave_section_data[0].logo}
            text={this.state.wave_section_data[0].text}
        />

        <a className="NavigatorAnchor" id="blog" name="blog">blog</a>
        <SectionCaption
            title="济济一堂"
            emoji="🎓"
            subtitle="未来你会遇到许多有趣的人和事"
        />
        <Blogs data={blogposts} />


        <WaveSection 
          index={1}
          onActivityChange={this.handleWaveActivity}
          image={this.state.wave_section_data[1].image}
          logo={this.state.wave_section_data[1].logo}
          text={this.state.wave_section_data[1].text}
        />


        <a className="NavigatorAnchor" id="better-live" name="better-live">better-live</a>
        <SectionCaption
            title="好好生活"
            emoji="🎬"
            subtitle="生活其实很简单生出来活下去"
        />
        <DeferredRender className="DeferredGallery">
          <Gallery data={photogallerys} avatars={this.state.avatars} />
        </DeferredRender>

        <WaveSection
          index={2}
          onActivityChange={this.handleWaveActivity}
          image={this.state.wave_section_data[2].image}
          logo={this.state.wave_section_data[2].logo}
          text={this.state.wave_section_data[2].text}
        />

        <a className="NavigatorAnchor" id="make-dreams" name="make-dreams">make-dreams</a>
        <TwentyTwoEntry />

        <FootprintsEntry />

        <WaveSection
          index={3}
          onActivityChange={this.handleWaveActivity}
          image={this.state.wave_section_data[3].image}
          logo={this.state.wave_section_data[3].logo}
          text={this.state.wave_section_data[3].text}
        />


        {/* coming sooning......... */}          
        <SectionCaption
            title="再慢一点"
            emoji="💭"
            subtitle="来  归  去"
        />
        <p className="ComingSoon">慢 下 来...</p>

        <div className="WebsiteStatisticGroup">
          <a href="https://clustrmaps.com/site/1bib3" title="Visit tracker"><img src="//www.clustrmaps.com/map_v2.png?d=oqY3PVNWDkZtpjzA-vOFtXGn2Ip19TQtX7EW7e_6Mcw&cl=ffffff" loading="lazy" decoding="async" alt="" /></a>
        </div>
        </main>

        {/* <button onClick={window.location.href="/blogs"}></button> */}
      </Layout>
    )
  }
}

export default RootIndex

export const pageQuery = graphql`
  query HomeQuery {
    site {
      siteMetadata {
        title
      }
    }
    allContentfulHero(sort: { fields: [createdAt], order: ASC }, filter: {page: {eq: "doubleZ"}}) {
      edges {
        node {
          name
          description
          quote
          bg {
            fluid(maxWidth: 1000){
              src
            }
          }
          color
        }
      }
    }
    allContentfulTag(sort: { fields: [orderRank, createdAt], order: ASC }) {
      edges {
        node {
          name
          description
          logo {
            fluid(maxWidth: 1000) {
              src
            }
          }
        }
      }
    }
    allContentfulBackground(
      filter: {type: {eq: "[AI生成] Nature & Time"}}
      sort: {fields: [name], order: ASC}
    ) {
      edges {
        node {
          bg {
            fluid(maxWidth: 1000){
              src
            }
          }
        }
      }
    }
    allContentfulMotto {
      edges {
        node {
          text
        }
      }
    }
    allContentfulAvatar(filter: {who: {eq: "doubleZ"}}) {
      edges {
        node {
          img {
            fluid(maxWidth: 1000){
              src
            }
          }
        }
      }
    }
    allContentfulSocialMedia (sort: { fields: [orderRank, createdAt], order: ASC }) {
      edges {
        node {
          fontclass
          color
          url
          title
        }
      }
    }
    allContentfulBlogPost(sort: { fields: [publishDate], order: DESC }) {
      edges {
        node {
          title
          slug
          publishDate(formatString: "YYYY-MM-DD")
          tags
          heroImage {
            fluid(maxWidth: 1000) {
              src
            }
          }
          description {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
    allContentfulPhotoGallery(sort: { fields: [time], order: DESC },  filter: {withYoyo: {ne: true}}) {
      edges {
        node {
          topic
          text1
          text2
          text3
          textEn1
          textEn2
          textEn3
          album {
            fluid {
              src
            }
          }
          withYoyo
        }
      }
    }
  }
`
